import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { styled} from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ViewListIcon from '@mui/icons-material/ViewList';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import MuiDrawer from '@mui/material/Drawer';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import SettingsIcon from '@mui/icons-material/Settings';
import Description from '@mui/icons-material/Description';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import PolicyIcon from '@mui/icons-material/Policy';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
/* import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight'; */
import { Collapse } from '@mui/material';
import UserAccount from './UserAccount';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { useHistory } from 'react-router-dom';
import { margin } from '@mui/system';
import { ROUTES } from '../../constants'
import { useSelector } from 'react-redux';
import { SocietiesList } from '../../Pages/Home/SocietiesList';
import { Dialog } from '@mui/material';
import { useSnackbar } from "notistack";
import { snackAction } from '../CustomSnakbar.jsx'
import { filePDF } from "../../assets/pdf";
import {countryHasExirosByCountryId} from "../../data/CountriesExiros.js"

const drawerWidth = 320;

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));
  
  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    backgroundColor: theme.palette.secondary.main,
      color: "white",
      "& .MuiListItem-button":{
      '&:hover':{
        backgroundColor:"rgb(0 165 73 / 72%)"
      }
      },
  });
  
  const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `${theme.spacing(7)}`,
    [theme.breakpoints.up('sm')]: {
      width: `${theme.spacing(7)} `,
    }, 
    backgroundColor: theme.palette.secondary.main,
      color: "white",
      "& .MuiListItem-button":{
      '&:hover':{
        backgroundColor:"rgb(0 165 73 / 72%)"
      }
      },
  });
  
  /* const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      backgroundColor: theme.palette.secondary.main,
      color: "white",
      "& .MuiListItem-button":{
      '&:hover':{
        backgroundColor:"rgb(0 165 73 / 72%)"
      }
      },
      ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
      }),
      ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
      }),
    }),
  ); */


const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      // position: 'relative',
      whiteSpace: 'nowrap',
      color: "white",
      width: drawerWidth,
      backgroundColor: theme.palette.secondary.main,
      flexShrink: 0,

      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
    "& .MuiListItem-button": {
      '&:hover': {
        backgroundColor: "rgb(0 165 73 / 72%)"
      }
    },
    ...(open && {
      ...openedMixin(theme),
      //'& .MuiDrawer-paper': openedMixin(theme),
    }),

    ...(!open && {
      ...closedMixin(theme),
      //'& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const useStyles = makeStyles((theme) => ({
  sideBarIcon: {
    color: 'white',
    marginLeft: "5px"
  },
  sideBartext: {
    color: 'white',
    fontSize: '2px',
    whiteSpace: 'normal'
  },
  bottomPush: {
    position: "fixed",
    bottom: 0,
    /* textAlign: "center", */
    /* paddingBottom: 10, */
  },
  /* longItem: {
    color: 'white',
    whiteSpace: 'normal'
  }, */
  subItem: {
    fontSize: '2px',
  },
  subItemIcon: {
    marginLeft: '70px', 
    /* marginRight: '20px' */
    fontSize: '2px',
  }
}));

export const MenuSideBar = ({ open, handleDrawerClose, theme, userLogged, children, onOpenFaqs }) => {

  const MEXICO =3;
  const ARGENTINA =1;
  const EEUU=2;
  const URUGUAY=4;
  
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const societies = useSelector(store => store.societies.data.filter(x=>x.selected));
  
  const [openInvoiceMenu, setOpenInvoiceMenu] = React.useState(false)
  const [openPolicyMenu, setOpenPolicyMenu] = React.useState(false)
  const [openSocietiesList, setOpenSocietiesList] = React.useState(false);

  const handleClickDownload = (pdf) => {
    history.push(ROUTES.HOME)
    window.open(pdf)
  }

  const handleDownloadPolicy = () => {
      const selectedArgentina = societies.some(x => x.countryId === ARGENTINA && x.selected);
      const selectedMexico = societies.some(x => x.countryId === MEXICO && x.selected);
      const selectedEeuu = societies.some(x => x.countryId === EEUU && x.selected);
      const selectedUruguay = societies.some(x => x.countryId === URUGUAY && x.selected);
  
      if (selectedArgentina) {
        history.push(ROUTES.HOME)
        window.open(filePDF.INFORMATION.POLITICAS_AR);
      } else if (selectedMexico) {
        history.push(ROUTES.HOME)
        window.open(filePDF.INFORMATION.POLITICAS_MX);
      } else if (selectedEeuu | selectedUruguay) {
        enqueueSnackbar("El país seleccionado no cuenta con una política disponible", {
          variant: "warning",
          action: snackAction,
          autoHideDuration: 2000,
        });
      } else {
        enqueueSnackbar("Debe seleccionar un país", {
          variant: "warning",
          action: snackAction,
          autoHideDuration: 2000,
        });
        history.push(ROUTES.SELECT_COUNTRY)
      }
  };

  const handleClickOpen = () => {
    if(societies && societies.length === 0){
      enqueueSnackbar("Debe seleccionar un país", { variant: "warning", action: snackAction, autoHideDuration: 2000 });
      history.push(ROUTES.SELECT_COUNTRY)

      return;
    }
    setOpenSocietiesList(true);
  };

  const handleClose = () => {
    setOpenSocietiesList(false);
  };

  const documentType = useSelector(store => store.documentType.data);

  const handleRedirect = (redirectTo) => (e) => {
    e.preventDefault();
    history.push(redirectTo);
    //dispatch(closeSidebar());
  };

  const handleClickMenu = (type) => {
    if (type === 'invoices') {
      setOpenInvoiceMenu(!openInvoiceMenu)
    }
    else if (type === 'policy') {
      setOpenPolicyMenu(!openPolicyMenu)
    }
  }

  const handleRedirectExternal = (url) => {
    window.open(url)
  }

  const handleRedirectTickets = () => {
    history.push(`${ROUTES.TICKETS_LIST}`);
  }

  const handleRedirectAccountStatus = () => {
    history.push(`${ROUTES.ACCOUNT_STATUS}`);
  }

  const hasExiros = countryHasExirosByCountryId(societies[0]?.countryId)
  return (
    <>

      <Drawer variant="permanent" open={open}>

        <DrawerHeader >
          <UserAccount fullWidth />
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon className={classes.sideBarIcon} /> : <ChevronLeftIcon className={classes.sideBarIcon} />}
            </IconButton>
          </Toolbar>
        </DrawerHeader>
        <Divider />
        <List style={{MuiTypographyRoot: '100px'}}>
          <ListItem button key="sdb-Home" onClick={handleRedirect(ROUTES.HOME)}>
            <ListItemIcon>
              <HomeRoundedIcon className={classes.sideBarIcon} />
            </ListItemIcon>
            <ListItemText primary="Home" className={classes.sideBartext} /* primaryTypographyProps={{fontSize: '15px'}} *//>
          </ListItem>
          <ListItem button key="sdb-Countries" onClick={handleRedirect(ROUTES.SELECT_COUNTRY)}>
            <ListItemIcon>
              <SettingsIcon className={classes.sideBarIcon} />
            </ListItemIcon>
            <ListItemText primary="Select Country" className={classes.sideBartext} />
          </ListItem>
          <Divider />
          <ListItem button key="sdb-Invoices" onClick={() => handleClickMenu('invoices')}>
            <ListItemIcon>
              <Description className={classes.sideBarIcon} />
            </ListItemIcon>
            <ListItemText primary="Carga Facturas" className={classes.sideBartext} />
            {openInvoiceMenu ? (
            <ExpandLessIcon/>
            ) : (
            <ExpandMoreIcon/>
            )}
          </ListItem>

          <Collapse in={open && openInvoiceMenu} timeout="auto" unmountOnExit >
          {LoadInvoiceSubMenu(hasExiros, classes, handleRedirect, ROUTES, documentType, handleRedirectExternal)}
          {/*   <ListItem button key="sdb-Materiales" className={classes.subItemIcon} onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")}>
              <ListItemText style={{whiteSpace: 'normal'}} primary="Materiales c/Pedido Compra" className={classes.sideBartext} />
            </ListItem>
            <ListItem button key="sdb-Servicios" className={classes.subItemIcon} onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")}>
              <ListItemText style={{whiteSpace: 'normal'}} primary="Servicios c/Pedido Compra" className={classes.sideBartext} />
            </ListItem>
            <ListItem button key="sdb-Pedido" className={classes.subItemIcon} onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")}>
              <ListItemText style={{whiteSpace: 'normal'}} primary="Sin Pedido Compra" className={classes.sideBartext} />
            </ListItem>
            <ListItem button key="sdb-Anticipos" className={classes.subItemIcon} onClick={handleRedirect(ROUTES.DOCUMENTS+documentType.find(x=>x.id===2)?.description) || []}>
              <ListItemText style={{whiteSpace: 'normal'}} primary="Anticipos" className={classes.sideBartext} />
            </ListItem>
            <ListItem button key="sdb-Nota" className={classes.subItemIcon} onClick={handleRedirect(ROUTES.DOCUMENTS+documentType.find(x=>x.id===5)?.description) || []}>
              <ListItemText style={{whiteSpace: 'normal'}} primary="Nota Crédito" className={classes.sideBartext} />
            </ListItem> */}
          </Collapse>

          <ListItem button key="sdb-Question" onClick={() => handleRedirectTickets("")}>
            <ListItemIcon>
              <QuestionAnswerIcon className={classes.sideBarIcon} />
            </ListItemIcon>
            <ListItemText primary="Consultas" className={classes.sideBartext} />
          </ListItem>
          
          {
            // HARDCODED
            /* (userLogged.email === "TEIC@TEIC.COM") | (userLogged.email === "cpaviglianiti@softtek.com") && ( */
            userLogged.email === "CPAVIGLIANITI@SOFTTEK.COM" && (
              <ListItem button key="sdb-AccountStatus" onClick={() => handleRedirectAccountStatus()}>
                <ListItemIcon>
                  <ViewListIcon className={classes.sideBarIcon} />
                </ListItemIcon>
                <ListItemText primary="Estado Cuenta" className={classes.sideBartext} />
              </ListItem>
            )
          }
          
          <ListItem button key="sdb-Policy" onClick={handleDownloadPolicy}>
            <ListItemIcon>
              <PolicyIcon className={classes.sideBarIcon} />
            </ListItemIcon>
            <ListItemText primary="Políticas Cupa" className={open && classes.sideBartext} />
          </ListItem>

          <ListItem button key="sdb-Legajos" onClick={handleClickOpen}>
            <ListItemIcon>
              <FileDownloadIcon className={classes.sideBarIcon} />
            </ListItemIcon>
            <ListItemText primary="Legajos Impositivos Sociedades TEIC" className={open && classes.sideBartext} />
          </ListItem>

          <ListItem button key="sdb-Faqs" onClick={() => onOpenFaqs && onOpenFaqs()}>
            <ListItemIcon>
              <HelpOutlineIcon className={classes.sideBarIcon} />
            </ListItemIcon>
            <ListItemText primary="FAQs" className={open && classes.sideBartext} />
          </ListItem>
        </List>
      </Drawer>
      {
        societies && societies.length > 0 &&
        <Dialog maxWidth="lg" onClose={handleClose} open={openSocietiesList}>
          <SocietiesList open={openSocietiesList} societies={societies} handleClickDownload={handleClickDownload} isDownload={true} />
        </Dialog>
      }
    </>
  )
}


const LoadInvoiceSubMenu = ( hasExiros, classes, handleRedirect, ROUTES, documentType, handleRedirectExternal ) => {

  if (hasExiros) {
    return <>  <ListItem button key="sdb-Materiales" className={classes.subItemIcon} onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")}>
      <ListItemText style={{ whiteSpace: 'normal' }} primary="Materiales c/Pedido Compra" className={classes.sideBartext} />
    </ListItem>
      <ListItem button key="sdb-Servicios" className={classes.subItemIcon} onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")}>
        <ListItemText style={{ whiteSpace: 'normal' }} primary="Servicios c/Pedido Compra" className={classes.sideBartext} />
      </ListItem>
      <ListItem button key="sdb-Pedido" className={classes.subItemIcon} onClick={() => handleRedirectExternal("https://suppliersworkplace.exiros.com/EPR/Portal/ ")}>
        <ListItemText style={{ whiteSpace: 'normal' }} primary="Sin Pedido Compra" className={classes.sideBartext} />
      </ListItem>
      <ListItem button key="sdb-Anticipos" className={classes.subItemIcon} onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 2)?.description) || []}>
        <ListItemText style={{ whiteSpace: 'normal' }} primary="Anticipos" className={classes.sideBartext} />
      </ListItem>
      <ListItem button key="sdb-Nota" className={classes.subItemIcon} onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 5)?.description) || []}>
        <ListItemText style={{ whiteSpace: 'normal' }} primary="Nota Crédito" className={classes.sideBartext} />
      </ListItem>
      <ListItem button key="sdb-FacturasProveedoresExterior" className={classes.subItemIcon} onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 8)?.description) || []}>
        <ListItemText style={{ whiteSpace: 'normal' }} primary="Facturas Proveedores Exterior" className={classes.sideBartext} />
      </ListItem></>
  }
  else {
    return <>
      <ListItem button key="sdb-FacturasProveedoresExterior" className={classes.subItemIcon} onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 1)?.description) || []}>
        <ListItemText style={{ whiteSpace: 'normal' }} primary="Facturas" className={classes.sideBartext} />
      </ListItem>
      <ListItem button key="sdb-Anticipos" className={classes.subItemIcon} onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 2)?.description) || []}>
        <ListItemText style={{ whiteSpace: 'normal' }} primary="Anticipos" className={classes.sideBartext} />
      </ListItem>
      <ListItem button key="sdb-Nota" className={classes.subItemIcon} onClick={handleRedirect(ROUTES.DOCUMENTS + documentType.find(x => x.id === 5)?.description) || []}>
        <ListItemText style={{ whiteSpace: 'normal' }} primary="Nota Crédito" className={classes.sideBartext} />
      </ListItem>

    </>
  }

}